<template>
  <div class="json-tree">
    <div v-for="entry in entries" :key="entry.key" class="json-node">
      <div
        class="json-node__line"
        :class="{ 'is-clickable': entry.complex }"
        :style="{ paddingLeft: depth * 14 + 'px' }"
        @click="toggle(entry)"
      >
        <span class="json-node__caret">{{ entry.complex ? (isOpen(entry) ? '▾' : '▸') : '' }}</span>
        <span class="json-node__key">{{ entry.key }}</span>
        <span class="json-node__colon">:</span>
        <span class="json-node__value" :class="'is-' + entry.type">{{ entry.preview }}</span>
      </div>
      <JsonTreeView
        v-if="entry.complex && isOpen(entry)"
        :value="entry.value"
        :depth="depth + 1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'JsonTreeView',
  props: {
    value: { type: [Object, Array, String, Number, Boolean], default: null },
    depth: { type: Number, default: 0 }
  },
  data() {
    return {
      collapsed: {}
    }
  },
  computed: {
    entries() {
      const v = this.value
      if (v && typeof v === 'object') {
        if (Array.isArray(v)) return v.map((item, i) => this.makeEntry(String(i), item))
        return Object.keys(v).map((k) => this.makeEntry(k, v[k]))
      }
      return [this.makeEntry('value', v)]
    }
  },
  methods: {
    makeEntry(key, value) {
      const type =
        value === null ? 'null' : Array.isArray(value) ? 'array' : typeof value
      const complex = type === 'object' || type === 'array'
      let preview
      if (complex) {
        preview = type === 'array' ? `[${value.length}]` : `{${Object.keys(value).length}}`
      } else if (type === 'string') {
        preview = JSON.stringify(value)
      } else {
        preview = String(value)
      }
      return { key, value, type, complex, preview }
    },
    isOpen(entry) {
      return !this.collapsed[entry.key]
    },
    toggle(entry) {
      if (!entry.complex) return
      this.$set(this.collapsed, entry.key, !this.collapsed[entry.key])
    }
  }
}
</script>

<style lang="scss" scoped>
.json-tree {
  font-family: 'Cascadia Code', 'Fira Code', 'JetBrains Mono', Consolas, monospace;
  font-size: 12px;
  line-height: 20px;
}

.json-node__line {
  display: flex;
  align-items: baseline;
  min-width: 0;
  border-radius: 3px;

  &.is-clickable {
    cursor: pointer;

    &:hover {
      background: rgba(74, 95, 243, 0.06);
    }
  }
}

.json-node__caret {
  flex-shrink: 0;
  width: 12px;
  color: #9aa8c0;
  font-size: 9px;
}

.json-node__key {
  color: #475569;
  flex-shrink: 0;
}

.json-node__colon {
  color: #94a3b8;
  margin-right: 4px;
}

.json-node__value {
  min-width: 0;
  word-break: break-all;

  &.is-string {
    color: #0f7b6c;
  }
  &.is-number {
    color: #b45309;
  }
  &.is-boolean {
    color: #7c3aed;
  }
  &.is-null {
    color: #94a3b8;
  }
  &.is-array,
  &.is-object {
    color: #94a3b8;
  }
}
</style>
